<template>
    <div>
        <b-breadcrumb v-if="this.$auth.check(['root'])">
            <b-breadcrumb-item :to="{ name: 'Ivr' }">Ivr</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'Polls' }">Encuesta</b-breadcrumb-item>
            <b-breadcrumb-item v-if="$route.name !== 'Poll'">{{ $route.meta.title }}</b-breadcrumb-item>
        </b-breadcrumb>
        <b-breadcrumb v-if="this.$auth.check(['admin'])">
            <b-breadcrumb-item :to="{ name: 'Ivr' }">Ivr</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'Polls' }">Encuesta</b-breadcrumb-item>
        </b-breadcrumb>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>